<script setup>
import { ref, onMounted } from "vue";
import { getImagePath } from "@/mixins/Helpers";

const props = defineProps({
    filename: { type: String, required: true },
    class: { type: String, },
    style: { type: String, },
});

const imagePath = ref(null);

onMounted(() => {
  getImagePath(props.filename)
    .then((path) => imagePath.value = path)
    .catch(() => { imagePath.value = null; });
});
</script>

<template>
  <img v-if="imagePath" :src="imagePath" :alt="props.filename" :class="props.class" :style="props.style"/>
</template>
